module.exports = __webpack_public_path__ + "static/media/loading.1067d7a8.svg";